// =========custom-add-to-cart=============

  const $sample_atc_submit_event = async function($form_data){
    const $sample_addtocart_result = await fetch('/cart/add.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify($form_data)
    });
    const $atc_success_result = await $sample_addtocart_result.json();
    if($atc_success_result.items){
      if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
      const quickAddModal = document.querySelector('quick-add-modal');
      if(quickAddModal){
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => { document.querySelector('cart-drawer').renderContents($atc_success_result) });
        }, {once: true});
        quickAddModal.hide(true);
      } else{
        document.querySelector('cart-drawer').renderContents($atc_success_result);
      }
    } else{
      document.querySelector('.block_cart-like-error').innerHTML = $atc_success_result.errors;
      setTimeout(function(){
         document.querySelector('.block_cart-like-error').innerHTML = "";
      } , 3000)
      console.error($atc_success_result);
    }
  }

// ==============card-product-tab-click============
let tabTitle = document.querySelectorAll(".block_tab-collection-tabtitle");
tabTitle.forEach((event) => {
        event.addEventListener('click', (tab) => {
            let _this = tab.target;
            [..._this.parentElement.children].forEach(sib => {
                sib.classList.remove('active')
                let protabId = sib.getAttribute("id");
                document.querySelector(`.block_tab-collection-products-list[data-id="${protabId}"]`).classList.add("hidden");
            });
            let ids = _this.getAttribute("id");
            _this.classList.add("active");
            document.querySelector(`.block_tab-collection-products-list[data-id="${ids}"]`).classList.remove("hidden");
            equl(".collection .card__heading a")
            equl(".collection .block_grid-card-vender-info")
        })
    })
// ==============foote.js============

let footerTitle = document.querySelectorAll(".footer-block .footer-block__heading");

footerTitle.forEach((event) => {
  event.addEventListener('click', (tab) => {
      let target = tab.target;
      let dataTitle = target.closest(".footer-block--menu");
      dataTitle.classList.toggle("active");
  })
})

// ================foryoumore products============

let featuredmore = document.querySelectorAll(".block_collection-button-click-more"); 
featuredmore.forEach((event) => {
  event.addEventListener('click', (tab) => {
    let target = tab.target;
    let featureddata = target.closest(".block_featured-foryou").querySelectorAll(".block_featured-foryou--data");
    featureddata.forEach(sib => {
    sib.classList.remove('hidden');
   });     
 }) 
})

// =========featuredforVideo=========
let featuredforVideo =  document.querySelectorAll(".block_featured-foryou--data-image video");
featuredforVideo.forEach((event) => {
  event.addEventListener('click', (tab) => {
    let target = tab.target;
     target.closest(".block_featured-foryou").querySelectorAll("video").forEach(sib => {
       sib.pause('active') 
     });
    target.play()
   });     
 }) 

// ======================card-product-details============

async function openPopup(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to load');
    
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const popupContent = doc.querySelector('.main_pro-show');
    const destination = document.querySelector('.block_detail-popup-body');
    
    if (popupContent && destination) {
      destination.innerHTML = popupContent.innerHTML;
      document.querySelector(".block_detail-popup").classList.remove("hidden");
      document.body.classList.add("over-hidden");
      setupClosePopupEvents();
    }
  } catch (error) {
    console.error("Popup error:", error);
  }
}

async function openOfferpopup(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to load');
    
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const popupContent = doc.querySelector('.main_pro-show-popup-main');
    const destination = document.querySelector('.block_detail-popup-body');
    
    if (popupContent && destination) {
      destination.innerHTML = popupContent.innerHTML;
      document.querySelector(".block_offer-popup").classList.remove("hidden");
      document.body.classList.add("over-hidden-offeropen");
      setupClosePopupEvents();
    }
  } catch (error) {
    console.error("Popup error:", error);
  }
}



function setupClosePopupEvents() {
  let closeButton = document.querySelector(".block_detail-popup-close");
  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }
   let closeButton2 = document.querySelector(".block_offer-popup-close");
  if (closeButton2) {
    closeButton2.addEventListener('click', closePopup2);
  }
  document.addEventListener('click', function (e) {
    let popupContainer = document.querySelector('.block_detail-popup-inner');
     let popupContainer2 = document.querySelector('.block_offer-popup-inner');
    let target = e.target;

    if (popupContainer && !popupContainer.contains(target) && !document.querySelector(".block_detail-popup").classList.contains("hidden")) {
      closePopup();
    }
    if (popupContainer2 && !popupContainer2.contains(target) && !document.querySelector(".block_offer-popup").classList.contains("hidden")) {
       closePopup2();
    }
    
  }, { once: true });

  
}

function closePopup() {
  let destination = document.querySelector('.block_detail-popup-body');
  document.querySelector("body").classList.remove("over-hidden");
  document.querySelector(".block_detail-popup").classList.add("hidden");
  destination.innerHTML = "";  // Clear the popup content
  
}
function closePopup2(){
  let destination = document.querySelector('.block_detail-popup-body');
  document.querySelector("body").classList.remove("over-hidden-offeropen");
  document.querySelector(".block_offer-popup").classList.toggle("hidden");
  destination.innerHTML = "";  // Clear the popup content
 
}

// let productDetailElements = document.querySelectorAll(".block_price-details-text");
// productDetailElements.forEach((element) => {
//   element.addEventListener('click', (event) => {
//     let url = event.target.getAttribute("data-url");
//     if (url) {
//       openPopup(url);  
//     }
//   });
// });


// ====================collection-line-text==========
let showmoreCollection = document.querySelectorAll(".block_card-offer-earn-info");
  showmoreCollection.forEach((event) => {
    event.addEventListener("click", (event) => {
  	let target = event.target;
  	target.classList.toggle("active")
  })
})
// ================ cart-drawer-like-it===========

function cartLikeit(){
    let cartswiper = new Swiper(".block_cart-drawer-likeit-product", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    mousewheel: {
      forceToAxis: true,
    },
    spaceBetween: 10,
   navigation: {
      nextEl: ".block_cart-drawer-likeit .block_slider-right-arrow",
      prevEl: ".block_cart-drawer-likeit .block_slider-left-arrow ",
    },
    observer: true,
    observeParents: true,
  });
}
cartLikeit();


function alosLikeit(e) {
	e.preventDefault(), e.stopImmediatePropagation();
	let sample_product_atc_array = [];
	sample_product_atc_array.push({
		id: e.target.getAttribute("data-id"),
		quantity: 1
	});
	let sample_product_atc_formData = {
		items: sample_product_atc_array,
		sections_url: window.location.pathname,
		sections: document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)
	};
	$sample_atc_submit_event(sample_product_atc_formData);
}

// ====================header-menu===================

let menuHover = document.querySelectorAll(".block_header-menu");
let headerHeight = document.querySelector(".header").offsetHeight;
let topBarHeight = document.querySelector(".utility-bar").offsetHeight;


menuHover.forEach((menu) => {
    menu.addEventListener("mouseover", (e) => {
        let target = e.target;
        let attribute = target.closest(".block_header-menu").getAttribute("data-id");
        let relatedMenuInfo = document.querySelector(`#${attribute}`);
        if (relatedMenuInfo) {
            relatedMenuInfo.classList.remove("hidden");     
            if(!document.body.classList.contains("header-hidden")){
              document.body.classList.add("header-hidden");    
            }
        }
    });

    menu.addEventListener("mouseleave", (e) => {
        let target = e.target;
        let attribute = target.closest(".block_header-menu").getAttribute("data-id");
        let relatedMenuInfo = document.querySelector(`#${attribute}`);
        if (relatedMenuInfo) {
            relatedMenuInfo.classList.add("hidden");
            if(document.body.classList.contains("header-hidden")){
             document.body.classList.remove("header-hidden");
            }  
        }
    });
});

let menuMouseHover = document.querySelectorAll(".block_header-menu-info");
menuMouseHover.forEach((menuInfo) => {
    menuInfo.addEventListener("mouseover", () => {
        menuInfo.classList.remove("hidden");
       if(!document.body.classList.contains("header-hidden")){
          document.body.classList.add("header-hidden");    
        }
     
    });

    menuInfo.addEventListener("mouseleave", () => {
        menuInfo.classList.add("hidden");
        if(document.body.classList.contains("header-hidden")){
          document.body.classList.remove("header-hidden");
         } 
    });
});



window.addEventListener("resize", () => {
    headerHeight = document.querySelector(".header").offsetHeight;
    topBarHeight = document.querySelector(".utility-bar").offsetHeight;
});

let menuTabProducts = document.querySelectorAll(".block_header-style-product-inner-info");

menuTabProducts.forEach((event) => {
  	event.addEventListener("click", (e) => {    
        let menuAttrrbute = e.target.closest(".block_header-style-product .block_header-style-product-inner-info").getAttribute("id");
        document.querySelectorAll(".block_header-style-product  .block_tab-collection-products-list").forEach(function(element) {
          	element.classList.add('hidden');  
        })
        document.querySelector(`.block_header-style-product .block_tab-collection-products-list[data-id = "${menuAttrrbute}"]`).classList.remove("hidden")
        equl(".block_header-style-product .collection .card__heading a")
        equl(".block_header-style-product .collection .block_grid-card-vender-info")
    })
})


document.addEventListener("input", function(event) {
    if (event.target.matches(".block__account-tabs-orders-search-input")) {      
        var filter = event.target.value.toUpperCase();
        document.querySelectorAll(".block__customer-order--detils").forEach(function(orderInfo) {
            var a = orderInfo.querySelector(".block__order_number p");
            var txtValue = a.textContent || a.innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                orderInfo.style.display = "";
            } else {
                orderInfo.style.display = "none";
            }
        });
      
    }
});


if(document.querySelectorAll(".block_mobile-search-icon").length > 0){
 document.querySelector(".block_mobile-search-icon").addEventListener("click" , (event) => {
        event.target.closest(".block_order-search").querySelector(".block__order-history-with-title").classList.toggle("active")
}) 
}
// ==============heade-men-drawe========
document.querySelector(".header__icon--menu").addEventListener("click" , () => {
  document.querySelector(".block_header-drawer-info").classList.add("active")
 document.querySelector("body").classList.add("over-hidden")
})
document.querySelector(".block_drawer-header-top .icon").addEventListener("click" , () => {
  document.querySelector(".block_header-drawer-info").classList.remove("active")
 document.querySelector("body").classList.remove("over-hidden")
})

document.addEventListener('click', function(e) {
    var container = document.querySelector('.block_header-drawer-info');
    var container2 = document.querySelector('.header__icon--menu');
    var target = e.target;   
    if (!container.contains(target) && !container2.contains(target) ) {
        var isContainerClicked = target.classList.contains('.block_header-drawer-info');
        var isDescendantClicked = container.contains(target);
        if (!isContainerClicked && !isDescendantClicked) {  
          document.querySelector(".block_header-drawer-info").classList.remove("active")
         document.querySelector("body").classList.remove("over-hidden")
        }
    }
});


let menuDrawerlist = document.querySelectorAll(".header-drawer-menus:not(.header-drawer-open)");
menuDrawerlist.forEach((event) => {
  event.addEventListener('click', (tab) => {   
     tab.target.classList.toggle("active")
  })
})

let menuDrawercatlist = document.querySelectorAll(".block_drawer-banner-category-blocks-info-image-info");

menuDrawercatlist.forEach((item) => {
  item.addEventListener('click', (event) => {
    const parentSection = event.target.closest(".block_drawer-banner-category-blocks-info");
    const linksSection = parentSection.querySelector(".block_drawer-banner-category-blocks-info-links");
    const innerLinks = parentSection.querySelector(".block_drawer-banner-category-blocks-info-links-inner");

    if (linksSection.classList.contains("active")) {
      linksSection.classList.remove("active");
      parentSection.style.height = "auto";
    } else {
      document.querySelectorAll(".block_drawer-banner-category-blocks-info").forEach((section) => {
        section.style.height = "auto";
        section.querySelector(".block_drawer-banner-category-blocks-info-links").classList.remove("active");
      });

      linksSection.classList.add("active");
      parentSection.style.height = `${innerLinks.offsetHeight + 110}px`;
    }

    if (typeof equl === "function") {
      equl(".block_drawer-banner-category-blocks-info-image-info");
    }
  });
});


if(document.querySelectorAll(".block_email-confirmation").length > 0 ){
  var live_url = window.location.href;
  var result = live_url.includes('=newsletter&form_type=customer#contact_form');
  var input_val = document.querySelector('.block_form-submitted-sucess .newsletter-form__field-wrapper .field__input ').value.length;
  if(result && input_val != 0){
    const add_ele = document.createElement("h3");
    add_ele.innerText = "You have already subscribed!";
    document.querySelector('.newsletter-form__field-wrapper').appendChild(add_ele);
    add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
  }
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1]);
}
document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(() => {
    if(document.querySelectorAll(".block_email-confirmation-inner").length > 0){
      var url_linkedin_url = getUrlParameter('email');  
     document.querySelector(".block_email-confirmation-inner .field__input").setAttribute("value" , `${_ltk_util.decode(url_linkedin_url)}`)  
     }
  }, 1000)

})

// ================card-collection-notify=========



let cardnotifyme = document.querySelectorAll(".block_notify_button");


cardnotifyme.forEach((event) => {
  event.addEventListener('click', (event) => {
    let notifyurl = event.target.getAttribute("data-url");
    // console.log("notifyurl" , notifyurl , event.target)
    //  openNotify(notifyurl);
  })
}) 




// ============back-in-stokc-popuo=========





function skuButton(event) {
  const sku = event.target.getAttribute("data-sku"); 
    document.querySelector("#back-stock-alert-cart #txtProductSKUcart").value = sku;
    document.querySelector(".block_back-in-stock-popup").classList.toggle("hidden");
    // document.body.classList.add("over-hidden-back");  
}
const productOpenClose = document.querySelector(".block_detail-notify-close");
if (productOpenClose) {
  productOpenClose.addEventListener("click", () => {
    document.querySelector(".block_back-in-stock-popup").classList.toggle("hidden");
    // document.body.classList.remove("over-hidden-back");
  });
}


function submitBack(event){
   event = event.target;
   let container = event.closest("#back-stock-alert-cart"); 
   let productSKU = container.querySelector("#txtProductSKUcart")?.value || "";
   let emailAddress = container.querySelector("#txtEmailAddresscart")?.value || "";
   let alertCode = container.querySelector("#hdnAlertCodecard")?.value || "";

      _ltk.Alerts.AddAlertWithIdentifiers({ Identifiers: { Email: emailAddress }, Sku: productSKU, AlertCode: alertCode });
      _ltk.Alerts.Submit();
      container.querySelector("#back_in-stock-card").innerHTML = "Thank you! We will notify you when this product becomes available.";
      setTimeout(() => {
        location.reload();
      }, 2000);

  }

document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.block_back-in-stock-popup').addEventListener('click', function(e) {          

    const popupInner = document.querySelector('.block_back-in-stock-popup-inner');
    const body = document.body;
    const closeButton = document.querySelector('.block_back-in-stock-popup-inner .block_detail-notify-close');

    if (popupInner && popupInner.contains(e.target)) {
        console.log('HEUEG');
    } else {
        console.log('CLOSE IT');
        // body.classList.remove('over-hidden-back');

        // Trigger click on close button using pure JavaScript
        if (closeButton) {
            closeButton.click();
        } else {
            console.warn('Close button not found.');
        }
    }

    console.log('over-hidden-back', this);
});
})